import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactInputMask from "react-input-mask";
import { Controller, useForm } from "react-hook-form";
//primereact
import { Button } from "primereact/button";
//components
import Input from "../../../components/input/Input";
import Select from "../../../components/input/Select";
import MaskInput from "../../../components/input/MaskInput";
import PasswordInput from "../../../components/input/PasswordInput";
//utils
import { api } from "../../../utils/api";
import { states } from "../../../utils/states";
//context
import { useCreateAccountContext } from "../../../context/CreateAccountContext";
//utils
import { handleCep } from "../../../utils/handleCep";

const FormData = () => {
  const form = useForm();
  const [doc, setDoc] = useState("");
  const [address, setAddress] = useState(null);
  const [errorUser, setErrorUser] = useState([false]);
  const [signatories, setSignatories] = useState([{}]);
  const [mask, setMask] = useState("99.999.999/9999-99");

  const { baseDataForm, setBaseDataForm, onSubmit } = useCreateAccountContext();

  const watchMask = (value) => {
    if (value.length <= 14) {
      setMask("999.999.999-999");
      setDoc(value);
    } else {
      setMask("99.999.999/9999-99");
      setDoc(value);
    }
  };

  async function handleDoc(doc, type, index) {
    const data = {
      doc: doc,
      type: type,
    };
    try {
      const response = await api.post("check-doc", data);
      if (response.data.doc_valid === false) {
        if (type === "environment") {
          // setErrorEnvironment("Documento Inválido");
          form.setError("doc_enterprise", {
            type: "manual",
            message: "Documento Inválido",
          });
        }
        if (type === "user") {
          const errors = [...errorUser];
          errors[index] = true;
          setErrorUser(errors);
        }
      } else {
        if (response.data.exists) {
          if (type === "environment") {
            // setErrorEnvironment("Documento ja cadastrado na Lote Mobile");
            form.setError("doc_enterprise", {
              type: "manual",
              message: "Documento ja cadastrado na Lote Mobile",
            });
          } else {
            const errors = [...errorUser];
            errors[index] = false;
            setErrorUser(errors);
          }
        } else {
          if (type === "environment") {
            // setErrorEnvironment(null);
            form.clearErrors("doc_enterprise");
            
            const isValidCPF = (doc) => {
              const cleanedDoc = doc.replace(/\D/g, "");
              return cleanedDoc.length === 11;
            };
            
            if (isValidCPF(doc)) {
              form.setValue("doc[0]", doc);
              
              const enterpriseName = form.getValues("name_enterprise");
              if (enterpriseName) {
                form.setValue("name[0]", enterpriseName);
              }
              
              const errors = [...errorUser];
              errors[0] = false;
              setErrorUser(errors);
            }
          }
          if (type === "user") {
            const errors = [...errorUser];
            errors[index] = false;
            setErrorUser(errors);
          }
        }
      }
    } catch (e) {
      if (type === "environment") {
        // setErrorEnvironment("Documento Inválido");
        form.setError("doc_enterprise", {
          type: "manual",
          message: "Documento Inválido",
        });
      }
      if (type === "user") {
        const errors = [...errorUser];
        errors[index] = true;
        setErrorUser(errors);
      }
    }
  }

  const handleAddSignatory = () => {
    setSignatories([...signatories, {}]);
    setErrorUser([...errorUser, false]);
  };

  const handleRemoveSignatory = (index) => {
    setSignatories((prevSignatory) =>
      prevSignatory.filter((_, i) => i !== index)
    );
    setErrorUser((prevError) => prevError.filter((_, i) => i !== index));
  };

  useEffect(() => {
    console.log("address", address);
    if (address && Object.keys(address).length !== 0) {
      form.setValue("address", address.address);
      form.setValue("city", address.city);
      form.setValue("neighborhood", address.neighborhood);
      form.setValue("state", address.state);
      form.clearErrors(["address", "city", "neighborhood", "state"]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address]);

  useEffect(() => {
    if (baseDataForm) {
      // console.log(baseDataForm);
      const isValidCPF = (doc) => {
        const cleanedDoc = doc.replace(/\D/g, "");
        return cleanedDoc.length === 11;
      };

      const isValidCNPJ = (doc) => {
        const cleanedDoc = doc.replace(/\D/g, "");
        return cleanedDoc.length === 14;
      };

      const getDocType = (doc) => {
        if (isValidCPF(doc)) return 1;
        if (isValidCNPJ(doc)) return 2;
        return null;
      };

      if (getDocType(baseDataForm.doc_enterprise) === 2)
        setMask("99.999.999/9999-99");

      setDoc(baseDataForm.doc_enterprise);
      form.setValue("doc", baseDataForm.doc);
      form.setValue("cep", baseDataForm.cep);
      form.setValue("num", baseDataForm.num);
      form.setValue("name", baseDataForm.name);
      form.setValue("city", baseDataForm.city);
      form.setValue("terms", baseDataForm.terms);
      form.setValue("email", baseDataForm.email);
      form.setValue("state", baseDataForm.state);
      form.setValue("address", baseDataForm.address);
      form.setValue("password", baseDataForm.password);
      form.setValue("complement", baseDataForm.complement);
      form.setValue("neighborhood", baseDataForm.neighborhood);
      form.setValue("doc_enterprise", baseDataForm.doc_enterprise);
      form.setValue("name_enterprise", baseDataForm.name_enterprise);
      form.setValue("email_enterprise", baseDataForm.email_enterprise);
      form.setValue("phone_enterprise", baseDataForm.phone_enterprise);
    } else {
      const savedData = localStorage.getItem("formData");
      if (savedData) {
        const parsedData = JSON.parse(savedData);
        // setBaseDataForm(parsedData);

        const newSignatories = [];
        Object.entries(parsedData).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((item, index) => {
              form.setValue(`${key}[${index}]`, item);

              if (key === "name" || key === "email" || key === "doc") {
                if (!newSignatories[index]) {
                  newSignatories[index] = {};
                }
                newSignatories[index][key] = item;
              }
            });
          } else {
            form.setValue(key, value);
          }
        });

        setSignatories(newSignatories);
        setErrorUser(newSignatories.map(() => false));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseDataForm]);

  return (
    <div>
      <div className="register-content mt-4">
        <form onSubmit={form.handleSubmit(onSubmit)} className="fs-13px">
          <div className="mb-3">
            <label className="fw-bold fs-4 text-teal">
              <i className="fa-solid fa-landmark"></i> Dados da Empresa
            </label>
            <hr />
            <div className="row gx-3">
              <div className="col-md-3">
                <Input
                  isRequired
                  type="text"
                  control={form.control}
                  errors={form.formState.errors}
                  label="Nome / Razão Social *"
                  name="name_enterprise"
                  className="form-control"
                />
              </div>
              <div className="col-md-3">
                <Controller
                  name="doc_enterprise"
                  control={form.control}
                  defaultValue=""
                  rules={{ required: "CPF / CNPJ é obrigatório" }}
                  render={({ field, fieldState }) => (
                    <>
                      <ReactInputMask
                        {...field}
                        mask={mask}
                        maskChar={null}
                        placeholder="CPF / CNPJ *"
                        className={`input-cpf ${
                          fieldState.error ? "input-error" : ""
                        } ${doc ? "input-filled" : ""}`}
                        onChange={(event) => {
                          field.onChange(event.target.value);
                          watchMask(event.target.value);
                        }}
                        onBlur={(e) => handleDoc(e.target.value, "environment")}
                      />
                      {fieldState.error && (
                        <span className="p-error">
                          {fieldState.error.message}
                        </span>
                      )}
                    </>
                  )}
                />
              </div>
              {/* <div className="col-md-3 mb-3">
                <Input
                  isRequired
                  name="email_enterprise"
                  errors={form.formState.errors}
                  control={form.control}
                  type="email"
                  validationRules={{
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: "E-mail inválido.",
                    },
                  }}
                  label="E-mail *"
                />
              </div> */}
              <div className="col-md-3">
                <MaskInput
                  name={`phone_enterprise`}
                  mask="(99) 99999-9999"
                  control={form.control}
                  isRequired
                  errors={form.formState.errors}
                  label={`Telefone *`}
                />
              </div>
            </div>
          </div>
          <div className="mt-3 mb-3">
            <label className="fw-bold fs-4 text-teal">
              <i className="fa-solid fa-map-location"></i> Endereço da Empresa
            </label>
            <hr />
            <div className="row gx-3">
              <div className="col-md-3">
                <MaskInput
                  name="cep"
                  mask="99999-999"
                  onComplete={() => handleCep(form.getValues("cep"), setAddress)}
                  control={form.control}
                  errors={form.formState.errors}
                  isRequired
                  label={`CEP *`}
                />
              </div>
              <div className="col-md-3">
                <Input
                  name="num"
                  control={form.control}
                  errors={form.formState.errors}
                  // placeholder="N.º"
                  label={`Número *`}
                  isRequired
                />
              </div>
              <div className="col-md-6">
                <Input
                  name="complement"
                  control={form.control}
                  errors={form.formState.errors}
                  // placeholder="Ex: Bloco A, apartamento 25"
                  label={`Complemento`}
                />
              </div>
              <div className="col-md-3 mt-2">
                <Input
                  name="city"
                  control={form.control}
                  errors={form.formState.errors}
                  // placeholder="Digite a Cidade"
                  label={`Cidade *`}
                  isRequired
                />
              </div>

              <div className="col-md-3 mt-2">
                <Select
                  name="state"
                  label={`Estado *`}
                  errors={form.formState.errors}
                  control={form.control}
                  options={states}
                />
              </div>
              <div className="col-md-3 mt-2">
                <Input
                  name="address"
                  control={form.control}
                  errors={form.formState.errors}
                  // placeholder="Ex: R. Catia Setima Montagni"
                  label={`Rua *`}
                  isRequired
                />
              </div>
              <div className="col-md-3 mt-2">
                <Input
                  name="neighborhood"
                  control={form.control}
                  errors={form.formState.errors}
                  // placeholder="Ex: Centro"
                  label={`Bairro *`}
                  isRequired
                />
              </div>
            </div>
          </div>
          <div className="mt-3 mb-3">
            <label className="fw-bold fs-4 text-teal">
              <i className="fa-solid fa-user-tie"></i> Dados de Acesso
            </label>
            <hr />
            <div className="gx-3">
              {signatories.map((_, index) => (
                <div key={index} className="row">
                  <div className="col-md-3 mb-2 mb-md-0">
                    <Input
                      isRequired
                      type="text"
                      control={form.control}
                      errors={form.formState.errors}
                      label="Nome Completo*"
                      name={`name[${index}]`}
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-3">
                    <ReactInputMask
                      required
                      mask="999.999.999-99"
                      maskChar={null}
                      {...form.register(`doc[${index}]`)}
                      onBlur={(e) => handleDoc(e.target.value, "user", index)}
                      placeholder="CPF *"
                      className={`input-cpf ${
                        errorUser[index] ? "input-error" : ""
                      } ${doc ? "input-filled" : ""}`}
                    />
                    {errorUser[index] && (
                      <span className="p-error">Documento Inválido</span>
                    )}
                  </div>
                  <div className="col-md-3 mb-3">
                    <Input
                      isRequired
                      name={`email[${index}]`}
                      errors={form.formState.errors}
                      control={form.control}
                      type="email"
                      validationRules={{
                        pattern: {
                          value:
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                          message: "E-mail inválido.",
                        },
                      }}
                      label="E-mail *"
                    />
                  </div>
                  {index === 0 && (
                    <div className="col-md-2 mb-4">
                      <PasswordInput
                        label="Senha *"
                        name="password"
                        errors={form.formState.errors}
                        control={form.control}
                        feedback={true}
                        rules={{ required: "Senha obrigatória." }}
                      />
                    </div>
                  )}
                  <div className="col-md-1 mt-4">
                    {index > 0 && (
                      <Button
                        rounded
                        outlined
                        type="button"
                        severity="danger"
                        icon="fa fa-minus"
                        onClick={() => handleRemoveSignatory(index)}
                        style={{
                          width: "2rem",
                          height: "2rem",
                          padding: "2px",
                        }}
                      />
                    )}
                    {index === signatories.length - 1 && (
                      <Button
                        rounded
                        outlined
                        type="button"
                        size="small"
                        severity="info"
                        icon="fa fa-plus"
                        onClick={handleAddSignatory}
                        className="mx-2"
                        style={{
                          width: "2rem",
                          height: "2rem",
                          padding: "2px",
                        }}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="row gx-3">
              <div className="form-check mb-4">
                <input
                  required
                  {...form.register("terms")}
                  className="form-check-input"
                  type="checkbox"
                  id="agreementCheckbox"
                />
                <label className="form-check-label" htmlFor="agreementCheckbox">
                  Ao clicar em Inscrever-se, você concorda com nossos{" "}
                  <Link
                    to="https://www.lotemobile.com.br/termos.php"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Termos
                  </Link>{" "}
                  e que você leu nossa{" "}
                  <Link
                    to="https://www.lotemobile.com.br/termos.php"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Política de Dados
                  </Link>
                  , incluindo nosso{" "}
                  <Link
                    to="https://www.lotemobile.com.br/termos.php"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Uso de Cookies
                  </Link>
                  .
                </label>
              </div>
            </div>
            <div className="d-flex text-end justify-content-center">
              <div className="col-md-3 text-end">
                <button
                  type="submit"
                  className="btn bg-teal text-white d-block w-100 btn-lg h-45px fs-13px"
                >
                  Continuar
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormData;
